export default __webpack_public_path__ + "static/media/Ankit Kesarwani.759cce58.webp";